/**
 * @author Hakim
 */
export enum MapButtonTypeEnum {
  DELETE_POINT = 'DELETE_POINT',
}
